import { MandatoryAmountValidator } from '@src/common/fields/AmountValidator';

export class MakePaymentAmountField {
  public static fieldName = 'paymentAmount' as const;
  public static validator = MandatoryAmountValidator;
}
